export function focusInvalid($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    require: 'form',
    link
  };

  function link(scope, elem, attrs, ctrl) {
    const focusFirstInvalid = () => {
      // do nothing if form is not submitted or valid
      if (!ctrl.$submitted || ctrl.$valid) {
        return;
      }

      $timeout(() => {
        // find the first invalid element
        const firstInvalid = elem[0].querySelector('.ng-invalid');
        // if we find one, set focus
        if (firstInvalid) {
          firstInvalid.focus();
        }
      }, 200);
    };

    // set up event handler on the form element
    elem.on('submit', focusFirstInvalid);
    scope.$on('form:validate', focusFirstInvalid);
  }
}

export function formValidityChanged() {
  'ngInject';

  return {
    restrict: 'A',
    require: 'form',
    link,
    scope: {
      formValidityChanged: '&'
    }
  };

  function link(scope, elem, attrs, ctrl) {
    if (scope.formValidityChanged) {
      scope.$watch(() => ctrl.$valid, () => {
        scope.formValidityChanged({ valid: ctrl.$valid });
      });
    }
  }
}
